const track = (action, params) => {
  if (window.gtag) {
    window.gtag('event', action, params)
  }
}

export default track
